import { ToastContentProps } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const OfflineToast: React.FC<ToastContentProps> = () => {
    return (
        <div style={{ 
            display: 'flex', 
            flexDirection: 'row', 
            alignItems: 'center',
            justifyContent: 'flex-start', 
            backgroundColor: '#FFF4E5',
            borderRadius: '4px !important',
            width: '100%',
        }}>
            <img src="/assets/icons/Wifi-orange.svg" alt="Offline" style={{ marginRight: '12px', marginBottom: '42px' }} />
            <div style={{ textAlign: 'left' }}> 
                <strong style={{ 
                    fontSize: '16px', 
                    color: '#663C00',
                    fontFamily: 'Jost'
                }}>Offline Mode</strong>
                <p style={{ 
                    fontSize: '14px', 
                    color: '#663C00',
                    fontFamily: 'Jost'
                }}>Your test results will save locally. Other features are limited.</p>
            </div>
        </div>
    );
};

export default OfflineToast;
